// Shared Google Tag Manager dataLayer helper.
// All site tracking calls (Vue components, partials, inline handlers) should
// go through this so event payloads stay consistent and pushes are always
// safe — even when GTM is absent (no container ID set on dev/staging).
//
// Usage: window.pushDataLayer('view_search_results', { search_term: 'care' });
window.pushDataLayer = function (event, data) {
    if (!event) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
};
